import { useEffect, useState } from "react";
import {
  Button,
  Grid,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  Divider,
} from "@material-ui/core";
import { FProveedoresStyle, StyledTextField } from "./styles";
import { ToastMessage } from "../../../global/ToastMessage";
import { useFormik } from "formik";
import useApi from "../../../hooks/useAPI";
import { useDispatch } from "react-redux";
import { obtenerProveedoresByIdAction, altaProveedorAction, actulizaProveedorAction } from "./../../../ducks/proveedorDuck";
import ModalBase from "./../../../global/ModalBase";
import HeaderModal from "../../../global/headerModal";
import UploadInput from "./../../../global/UploadInput";
import { getBase64 } from "./../../../utils/fileBase64";
import BackDrop from "../../../global/BackDrop";
import * as yup from "yup";
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const validationSchema = yup.object({
  nombreProveedor: yup.string("Ingresa un nombre").required("Nombre es requerido"),
  razonSocial: yup.string("Ingresa una razón social").required("Razón social es requerido"),
  rfc: yup.string("Ingresa un RFC").required("RFC es requerido"),
  email: yup.string("Ingresa un email").email('Email invalido').required('Email es requerido'),
  nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
  apPaterno: yup.string("Ingresa un apellido paterno").required("Ingresa un apellido paterno"),
  apMaterno: yup.string("Ingresa un apellido materno").optional(),
  telefono: yup.string("Ingresa un telefono").matches(phoneRegExp, 'Numero de telefono invalido').required("Telefono es requerido"),
  direccion: yup.string("Ingresa un direccion").required("Direccion es requerido"),
});

export default function FProveedor(props) {

  const {
    open = true,
    setOpen = () => { },
    rowData = {},
    editar = false,
    setEditar = () => { },
  } = props;

  const InitialValues = {
    nombreProveedor: "",
    razonSocial: "",
    rfc: "",
    email: "",
    nombre: "",
    apPaterno: "",
    apMaterno: "",
    telefono: "",
    direccion: "",
  }

  const classes = FProveedoresStyle();
  const dispatch = useDispatch();
  const [file, setFile] = useState([]);
  const [tipoProveedor, setTipoProveedor] = useState(0);
  const [isLoad, setIsload] = useState(false);
  const catalogoTipoProveedor = useApi(`/Catalog/TipoProveedor`);
  const [oldEmail, setOldEmail] = useState("")
  const formik = useFormik({
    initialValues: InitialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (editar)
        onUpdate();
      else
        onSave();
    },
  });
  useEffect(() => {
    const buscar = () => {
      setIsload(true);
      dispatch(obtenerProveedoresByIdAction(rowData.IdProveedor)).then(
        (Response) => {
          let Proveedor = Response;
          formik.setFieldValue("nombreProveedor", Proveedor?.Nombre);
          formik.setFieldValue("razonSocial", Proveedor?.RazonSocial);
          formik.setFieldValue("rfc", Proveedor?.RFC);
          formik.setFieldValue("email", Proveedor?.Email);
          formik.setFieldValue("direccion", Proveedor?.DireccionOficina);
          setOldEmail(Proveedor?.Email)
          if (Proveedor?.Contacto) {
            formik.setFieldValue("nombre", Proveedor?.Contacto?.Nombre);
            formik.setFieldValue("apPaterno", Proveedor?.Contacto?.ApellidoPaterno);
            formik.setFieldValue("apMaterno", Proveedor?.Contacto?.ApellidoMaterno);
            formik.setFieldValue("telefono", Proveedor?.Contacto?.Telefono);
          }
          setFile([]);
          if (Proveedor?.TipoProveedor)
            setTipoProveedor(Proveedor.TipoProveedor[0]?.IdTipoProveedor);

          setIsload(false);
        }
      );
    };
    if (editar) buscar();
  }, [dispatch, rowData.IdProveedor, editar]); // eslint-disable-line react-hooks/exhaustive-deps

  const LimpiarForm = () => {
    formik.resetForm(InitialValues);
    setTipoProveedor(0);
    setFile([]);
  };

  const handleClose = () => {
    setOpen(!open);
    LimpiarForm();
    setEditar(false);
  };

  const onUpdate = () => {
    setIsload(true);
    if (file.length > 0) {
      file.forEach(async (archivo) => {
        await getBase64(archivo).then((result) => {
          const Logobase64 = String(result).split(",")[1];
          let payload = {
            NombreProveedor: formik.values.nombreProveedor,
            IdProveedor: rowData.IdProveedor,
            RazonSocial: formik.values.razonSocial,
            RFC: formik.values.rfc,
            Email: (formik.values.email !== oldEmail) ? formik.values.email : null,
            EmailReserva: formik.values.email,
            Nombre: formik.values.nombre,
            ApellidoPaterno: formik.values.apPaterno,
            ApellidoMaterno: formik.values.apMaterno,
            Telefono: formik.values.telefono,
            DireccionOficina: formik.values.direccion,
            IdTipoProveedor: tipoProveedor,
            Actualiza: 1,
            LogoExtension: archivo.name.split(".")[archivo.name.split(".").length - 1],
            LogoBase64: Logobase64,
          };
          dispatch(actulizaProveedorAction(payload, rowData.IdProveedor)).then((Response) => {
            switch (Response.status) {
              case 400:
                ToastMessage.fire({
                  icon: "warning",
                  title: "<strong>Atención</strong>",
                  text: Response.Message ? `${Response.Message}` : `Ocurrio un problema inesperado`,
                });
                break;
              case 500:
                ToastMessage.fire({
                  icon: "error",
                  title: Response.Message ? `${Response.Message}` : `Ha habido un problema de conexión con el servidor`,
                });
                break;
              default:
                handleClose();
                ToastMessage.fire({
                  icon: "success",
                  title: "Ingreso Correcto",
                });
                break;
            }
            setIsload(false);
          })
        })
      })
    } else {
      let payload = {
        NombreProveedor: formik.values.nombreProveedor,
        IdProveedor: rowData.IdProveedor,
        RazonSocial: formik.values.razonSocial,
        RFC: formik.values.rfc,
        Email: (formik.values.email !== oldEmail) ? formik.values.email : null,
        EmailReserva: formik.values.email,
        Nombre: formik.values.nombre,
        ApellidoPaterno: formik.values.apPaterno,
        ApellidoMaterno: formik.values.apMaterno,
        Telefono: formik.values.telefono,
        DireccionOficina: formik.values.direccion,
        IdTipoProveedor: tipoProveedor,
        Actualiza: 1,
      };
      dispatch(actulizaProveedorAction(payload, rowData.IdProveedor)).then((Response) => {
        switch (Response.status) {
          case 400:
            ToastMessage.fire({
              icon: "warning",
              title: "<strong>Atención</strong>",
              text: Response.Message ? `${Response.Message}` : `Ocurrio un problema inesperado`,
            });
            break;
          case 500:
            ToastMessage.fire({
              icon: "error",
              title: Response.Message ? `${Response.Message}` : `Ha habido un problema de conexión con el servidor`,
            });
            break;
          default:
            handleClose();
            ToastMessage.fire({
              icon: "success",
              title: "Ingreso Correcto",
            });
            break;
        }
        setIsload(false);
      })
    }
  };

  const onSave = () => {
    if (file.length > 0) {
      setIsload(true);
      file.forEach(async (archivo) => {
        await getBase64(archivo).then((result) => {
          const Logobase64 = String(result).split(",")[1];
          let payload = {
            NombreProveedor: formik.values.nombreProveedor,
            RazonSocial: formik.values.razonSocial,
            RFC: formik.values.rfc,
            Email: formik.values.email,
            EmailReserva: formik.values.email,
            Nombre: formik.values.nombre,
            ApellidoPaterno: formik.values.apPaterno,
            ApellidoMaterno: formik.values.apMaterno,
            Telefono: formik.values.telefono,
            LogoExtension: archivo.name.split(".")[archivo.name.split(".").length - 1],
            LogoBase64: Logobase64,
            DireccionOficina: formik.values.direccion,
            IdTipoProveedor: tipoProveedor,
          };
          dispatch(altaProveedorAction(payload)).then((Response) => {
            switch (Response.status) {
              case 400:
                ToastMessage.fire({
                  icon: "warning",
                  title: "<strong>Atención</strong>",
                  text: Response.Message ? `${Response.Message}` : `Ocurrio un problema inesperado`,
                });
                break;
              case 500:
                ToastMessage.fire({
                  icon: "error",
                  title: Response.Message ? `${Response.Message}` : `Ha habido un problema de conexión con el servidor`,
                });
                break;
              default:
                handleClose();
                ToastMessage.fire({
                  icon: "success",
                  title: "Ingreso Correcto",
                });
                break;
            }
            setIsload(false);
          })
        })
      })
    } else {
      ToastMessage.fire({
        icon: "warning",
        title: "<strong>Atención</strong>",
        text: "No se ha adjuntado alguna imagen.",
      });
    }
  };

  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        handleClose={handleClose}
        titulo={editar ? "Actuliza proveedor" : "Nuevo proveedor"}
      />
      <form onSubmit={formik.handleSubmit}>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={4}>
            <StyledTextField
              required
              id="txtNombreProveedor"
              label="Clave"
              name="nombreProveedor"
              type="text"
              variant="outlined"
              value={formik.values.nombreProveedor}
              onChange={formik.handleChange}
              error={formik.touched.nombreProveedor && Boolean(formik.errors.nombreProveedor)}
              helperText={formik.touched.nombreProveedor && formik.errors.nombreProveedor}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <StyledTextField
              required
              id="txtRazonSocial"
              label="Razón Social"
              type="text"
              variant="outlined"
              name="razonSocial"
              value={formik.values.razonSocial}
              onChange={formik.handleChange}
              error={formik.touched.razonSocial && Boolean(formik.errors.razonSocial)}
              helperText={formik.touched.razonSocial && formik.errors.razonSocial}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <StyledTextField
              required
              id="txtRFC"
              label="RFC"
              type="text"
              variant="outlined"
              name="rfc"
              value={formik.values.rfc}
              onChange={formik.handleChange}
              error={formik.touched.rfc && Boolean(formik.errors.rfc)}
              helperText={formik.touched.rfc && formik.errors.rfc}
              className={classes.textField}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={4}>
            <StyledTextField
              required
              id="txtEmail"
              label="Correo"
              type="text"
              variant="outlined"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <StyledTextField
              id="txtDireccion"
              label="Dirección "
              type="text"
              variant="outlined"
              name="direccion"
              value={formik.values.direccion}
              onChange={formik.handleChange}
              error={formik.touched.direccion && Boolean(formik.errors.direccion)}
              helperText={formik.touched.direccion && formik.errors.direccion}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="lTipoProveedor">Tipo proveedor</InputLabel>
              <Select
                labelId="lTipoProveedor"
                id="STipoProveedor"
                value={tipoProveedor}
                onChange={(e) => {
                  setTipoProveedor(e.target.value);
                }}
                label="Tipo proveedor"
              >
                <MenuItem value="0" disabled>
                  <em>Seleccione una opción</em>
                </MenuItem>
                {catalogoTipoProveedor.map((item, index) => (
                  <MenuItem
                    key={item.IdTipoProveedor}
                    value={item.IdTipoProveedor}
                  >
                    {item.Descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12}>
            <Divider />
            <h4>Información de Contacto</h4>
          </Grid>
          <Grid item xs={4}>
            <StyledTextField
              required
              id="txtNombre"
              label="Nombre(s)"
              type="text"
              variant="outlined"
              name="nombre"
              value={formik.values.nombre}
              onChange={formik.handleChange}
              error={formik.touched.nombre && Boolean(formik.errors.nombre)}
              helperText={formik.touched.nombre && formik.errors.nombre}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <StyledTextField
              required
              id="txtApellidoPaterno"
              label="ApellidoPaterno"
              type="text"
              variant="outlined"
              name="apPaterno"
              value={formik.values.apPaterno}
              onChange={formik.handleChange}
              error={formik.touched.apPaterno && Boolean(formik.errors.apPaterno)}
              helperText={formik.touched.apPaterno && formik.errors.apPaterno}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <StyledTextField
              id="txtApellidoMaterno"
              label="Apellodo Materno"
              type="text"
              variant="outlined"
              name="apMaterno"
              value={formik.values.apMaterno}
              onChange={formik.handleChange}
              error={formik.touched.apMaterno && Boolean(formik.errors.apMaterno)}
              helperText={formik.touched.apMaterno && formik.errors.apMaterno}
              className={classes.textField}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={4}>
            <StyledTextField
              required
              id="txtTelefono"
              label="Teléfono"
              type="text"
              variant="outlined"
              name="telefono"
              value={formik.values.telefono}
              onChange={formik.handleChange}
              error={formik.touched.telefono && Boolean(formik.errors.telefono)}
              helperText={formik.touched.telefono && formik.errors.telefono}
              className={classes.textField}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12}>
            <Divider />
            <h4>Imagen de proveedor</h4>
          </Grid>
          <Grid item xs={12}>
            <UploadInput
              files={file}
              setFiles={setFile}
              multiple={false}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12} className={classes.modalBotonesCenter}>
            <Button
              type="Submit"
              variant="contained"
              color="primary"
              className={classes.modalBoton}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </form>
      <BackDrop open={isLoad} />
    </ModalBase>
  );
}

